import _ from 'lodash';
import {
    REVENUE_BASED_LOAN_PRODUCT_TYPE,
    FLEXI_LOAN_PRODUCT_TYPE
} from '../../myAccount/multiLoanDashboard/accountsSelector';
import { RootState } from '@iwProvider/configureStore';
import { GetProductOffersResponse } from '@iwoca/lapi-client/edge';

export const DOC_TYPES = {
    VAT_RETURN: 'vat_return',
    BANK_STATEMENT: 'bank_statement',
    COMPANY_ACCOUNTS: 'company_accounts',
    MANAGEMENT_ACCOUNTS: 'management_accounts',
    AGED_DEBTOR_REPORT: 'aged_debtor_report',
    OUTSTANDING_DEBT_INFORMATION: 'outstanding_debt_information',
    CASHFLOW_FORECAST: 'cashflow_forecast',
    SELF_ASSESSMENT_TAX_RETURN: 'self_assessment_tax_return'
};

export function hasDocsComplete(state: RootState) {
    const suggestedProduct = getSuggestedProduct(state);
    if (!suggestedProduct) return true;

    return hasProductDocsComplete(suggestedProduct);
}

export function getSuggestedProduct(state: RootState) {
    const allProducts = _.get(state, 'api.product_offers.data.products');

    return _.find(allProducts, (product) => product.is_suggested);
}

export function hasProductDocsComplete(
    product: NonNullable<GetProductOffersResponse['data']>['products'][number]
) {
    const incompleteDocumentRequirements = product.data_requirements.filter(
        (dataRequirement) =>
            dataRequirement.category === 'documents' &&
            (dataRequirement.status === 'required' ||
                dataRequirement.status === 'error') &&
            !dataRequirement.is_optional
    );

    return !(
        incompleteDocumentRequirements && incompleteDocumentRequirements.length
    );
}

export function getRBLMaxAmount(state: RootState) {
    const allProducts: NonNullable<
        GetProductOffersResponse['data']
    >['products'] = _.get(state, 'api.product_offers.data.products');

    const RBLproductOffers = _.filter(
        allProducts,
        (product) => product.product_type === REVENUE_BASED_LOAN_PRODUCT_TYPE
    );
    // @ts-expect-error _.max only accepts an array, there's likely a bug here.
    const RBLMaxOffer = _.max(RBLproductOffers, (product) => product.amount);

    if (RBLMaxOffer) return RBLMaxOffer.amount;
    return 100000;
}

export function getMaxFlexiLoanAmount(state: RootState) {
    const allProducts = _.get(state, 'api.product_offers.data.products');

    const FLProductOffers = _.filter(
        allProducts,
        (product) => product.product_type === FLEXI_LOAN_PRODUCT_TYPE
    );
    const FLMaxOffer = _.max(_.map(FLProductOffers, 'amount'));

    if (FLMaxOffer) return FLMaxOffer;
    return 500000;
}
